import { render, staticRenderFns } from "./aviationExchangePriceBatchConfig.vue?vue&type=template&id=c99ffe0c&scoped=true&"
import script from "./aviationExchangePriceBatchConfig.vue?vue&type=script&lang=js&"
export * from "./aviationExchangePriceBatchConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99ffe0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c99ffe0c')) {
      api.createRecord('c99ffe0c', component.options)
    } else {
      api.reload('c99ffe0c', component.options)
    }
    module.hot.accept("./aviationExchangePriceBatchConfig.vue?vue&type=template&id=c99ffe0c&scoped=true&", function () {
      api.rerender('c99ffe0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/aviationExchangePriceBatchConfig.vue"
export default component.exports